import interpolateArray from './interpolateArray'

let config = {
  bufferLen: 1024,
  numChannels: 1,
  mimeType: 'audio/wav'
}

let recording = false
let initDone = false

let globalSampleRate = 0
let ARRAY_BUFFER_DATA = new Float32Array(0)
let recLength = 0,
  recBuffers: any = [],
  numChannels: any

// let totalNumberOfSilence = 0

const init = async (
  stream: any,
  updateNumberOfSilence: any,
  recordingConfig = config
) => {
  if (initDone) {
    return
  }
  config = { ...recordingConfig, ...config }
  const audioContext = new AudioContext()
  globalSampleRate = audioContext.sampleRate
  const source = await audioContext.createMediaStreamSource(stream)
  const context = source.context
  numChannels = config.numChannels

  initBuffers()
  const { createScriptProcessor } = audioContext
  const node = createScriptProcessor.call(audioContext, 1024, 1, 1)

  source.connect(node)
  node.connect(context.destination)
  node.onaudioprocess = function (audioEvent) {
    if (!recording) return
    const input = audioEvent.inputBuffer.getChannelData(0);
    ARRAY_BUFFER_DATA = Float32Concat(ARRAY_BUFFER_DATA, input)
  }
  initDone = true
}


const Float32Concat = (first: any, second: any) => {
  const firstLength = first.length,
    result = new Float32Array(firstLength + second.length)
  result.set(first);
  result.set(second, firstLength);
  return result;
}


const start = () => {
  clear()
  recording = true
}

const stop = () => {
  recording = false
  console.log('globalSampleRate', globalSampleRate)
  const input = downsample(ARRAY_BUFFER_DATA, globalSampleRate, 16000)
  // convert float audio data to 16-bit PCM
  const buffer = new ArrayBuffer(input.length * 2)
  const output = new DataView(buffer);
  for (let i = 0, offset = 0; i < input.length; i++, offset += 2) {
    const s = Math.max(-1, Math.min(1, input[i]));
    output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
  }
  ARRAY_BUFFER_DATA = new Float32Array(0)
  console.log('cleared array buffer data')
  console.log('ARRAY_BUFFER_DATA', ARRAY_BUFFER_DATA)
  return buffer
}


const downsample = (buffer: any, fromSampleRate: any, toSampleRate: any) => {
  // buffer is a Float32Array
  const sampleRateRatio = Math.round(fromSampleRate / toSampleRate);
  const newLength = Math.round(buffer.length / sampleRateRatio);

  const result = new Float32Array(newLength);
  let offsetResult = 0;
  let offsetBuffer = 0;
  while (offsetResult < result.length) {
    const nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
    let accum = 0, count = 0;
    for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
      accum += buffer[i];
      count++;
    }
    result[offsetResult] = accum / count;
    offsetResult++;
    offsetBuffer = nextOffsetBuffer;
  }
  console.log('fromSampleRate', fromSampleRate)
  console.log('toSampleRate', toSampleRate)
  console.log('sampleRateRatio', sampleRateRatio)
  console.log('newLength', newLength)
  console.log('result', result)
  return result;
}

const clear = () => {
  recLength = 0
  recBuffers = []
  initBuffers()
}

const initBuffers = () => {
  for (let channel = 0; channel < numChannels; channel++) {
    recBuffers[channel] = []
  }
}

const mergeBuffers = (recBuffers: any, recLength: any) => {
  const result = new Float32Array(recLength)
  let offset = 0
  for (let i = 0; i < recBuffers.length; i++) {
    result.set(recBuffers[i], offset)
    offset += recBuffers[i].length
  }
  return result
}

const interleave = (inputL: any, inputR: any) => {
  const length = inputL.length + inputR.length
  const result = new Float32Array(length)

  let index = 0,
    inputIndex = 0

  while (index < length) {
    result[index++] = inputL[inputIndex]
    result[index++] = inputR[inputIndex]
    inputIndex++
  }
  return result
}

const floatTo16BitPCM = (output: any, offset: any, input: any) => {
  for (let i = 0; i < input.length; i++, offset += 2) {
    const s = Math.max(-1, Math.min(1, input[i]))
    output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true)
  }
}

const writeString = (view: any, offset: any, string: any) => {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i))
  }
}


export default { init, start, stop }
